export default function TruncatedText({
  text,
  maxLength = 100,
}: {
  text: string | null;
  maxLength?: number;
}) {
  if (!text) return null;

  const truncated =
    text.length > maxLength ? text.slice(0, maxLength) + "..." : text;

  return <span className="truncate block cursor-pointer">{truncated}</span>;

  // return text.length <= maxLength ? (
  //   <span className="truncate block cursor-pointer">{truncated}</span>
  // ) : (
  //   <Popover.Root>
  //     <Popover.Trigger openOnHover>
  //       <span className="truncate block cursor-pointer">{truncated}</span>
  //     </Popover.Trigger>
  //     <Popover.Portal>
  //       <Popover.Positioner sideOffset={8}>
  //         <Popover.Popup className="max-w-sm rounded-sm px-2 py-1 bg-black shadow-sm shadow-gray-200 outline-gray-200 transition-[transform,scale,opacity] data-[ending-style]:scale-90 data-[ending-style]:opacity-0 data-[starting-style]:scale-90 data-[starting-style]:opacity-0">
  //           <Popover.Description className="text-sm text-white">
  //             {text}
  //           </Popover.Description>
  //         </Popover.Popup>
  //       </Popover.Positioner>
  //     </Popover.Portal>
  //   </Popover.Root>
  // );
}
